export default __webpack_public_path__ + "static/media/69.41084ce1.png";